export default {
    instanceSuffix: process.env.INSTANCE_SUFFIX || 'local',
    gaKey: process.env.GOOGLE_ANALYTICS_API_KEY,
    stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY,
};



// WEBPACK FOOTER //
// ./src/config/index.js